/**
 * Created by calhosh on 1/22/2025
 */
import _ from 'lodash';
import initialstate from '../initialstate';
import {GET_AICHATBOT_INTEGRATION_PARAMETERS, GET_CURRENT_HEADER_AND_SECTION} from '../../actions/actiontypes';

export default function AIChatBotIntegrationParametersReducer(
	state = initialstate.aiChatBotIntegrationParameters,
	action
) {
	switch (action.type) {
		case GET_AICHATBOT_INTEGRATION_PARAMETERS: {
			return {
				...state,
				data: action.response
			};
		}
		case GET_CURRENT_HEADER_AND_SECTION: {
			const abc = action.response;
			return {
				...state,
				headerId: abc?.headerId,
				sectionId: abc?.sectionId
			};
		}
		default:
			return state;
	}
}
